export interface Location {
  x: number | null;
  y: number | null;
}

export interface FixedPaymentRate {
  paymentRate: number | null;
  paymentRateType: string | null;
}

export interface RangePaymentRate {
  max: number | null;
  min: number | null;
  paymentRateType: string | null;
}

export interface PaymentRate {
  fixedPaymentRate: FixedPaymentRate;
  rangePaymentRate: RangePaymentRate;
}

export interface JobInput {
  activeUntil: string | null;
  ageGroups: string[] | null;
  careType: string | null;
  description: string | null;
  languages: string[] | null;
  location: Location;
  numberOfChildren: number | null;
  paymentRate: PaymentRate;
  schedule: any;
}

export interface JobState {
  jobInput: JobInput;
}

export const state: JobState = {
  jobInput: {
    activeUntil: null,
    ageGroups: null,
    careType: null,
    description: null,
    languages: null,
    location: {
      x: null,
      y: null,
    },
    numberOfChildren: null,
    paymentRate: {
      fixedPaymentRate: {
        paymentRate: null,
        paymentRateType: null,
      },
      rangePaymentRate: {
        max: null,
        min: null,
        paymentRateType: null,
      },
    },
    schedule: null,
  },
};
